<template>
  <div style="display: flex;flex-direction: column;cursor: auto;user-select: text;">
    <el-form :model="form" :rules="rules" :inline="true" ref="form" label-width="100px">
		<div style="display: flex;align-items: center;">
			<div style="display: flex;flex-wrap: wrap; align-items: center;flex: 1;">
				<el-form-item label="目的地" prop="countryCode" class="medium-form-item">
					<el-select v-model="form.countryCode" ref="inputCountryCode" filterable default-first-option remote :remote-method="filterCountry" @change="changeCountry" clearable @keyup.enter.native="valueDeclaredkeyupEnter" placeholder="请选择目的地">
						<el-option :value="country.countryCode" :label="country.nameChinese" v-for="(country,i) in countryOptionsCrror" :key="i">{{country.countryCode}}<el-divider direction="vertical"></el-divider>{{country.nameChinese}}<el-divider direction="vertical"></el-divider>{{country.nameEnglish}}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="结算重" prop="weightText" class="short-form-item">
					<!-- <el-input v-model="weightText" :readOnly="weightText=='按尺寸'" onkeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))" class="shortinput" ref="inputWeight" clearable @keyup.enter.native="weightkeyupEnter"></el-input> -->
					<el-input v-model="form.weightText" class="shortinput" ref="inputWeight"  clearable
						  @clear="weightClear" @keyup.enter.native="weightkeyupEnter" placeholder="请录入重量"></el-input>
					<el-button @click="btnSizeClick">尺寸</el-button>						  
				</el-form-item>
				<el-form-item label="类型" prop="goodsType" class="short-form-item">
					<el-select v-model="form.goodsType">
					  <el-option v-for="item in goodsTypeOptions" :key="item" :label="item.label" :value="item.value">
					  </el-option>
					</el-select>
				</el-form-item>      
				<el-form-item label="邮编" prop="postCode" class="short-form-item">
					<el-select v-model="form.postCode" :disabled="!form.countryCode" filterable default-first-option remote :remote-method="remoteMethodPostCode" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择邮编'">
						<el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市" prop="cityName" class="medium-form-item">
					<el-select v-model="form.cityName" :disabled="!form.countryCode" filterable default-first-option remote :remote-method="remoteMethodCityName" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择城市'">
						<el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
					</el-select>
				</el-form-item>            
				<el-form-item label="服务商" prop="providerCode" class="medium-form-item">
					<el-cascader v-model="form.providerDepartment" :options="providerOptions" 
									:props="{ checkStrictly: true, expandTrigger: 'hover' }"></el-cascader>
				</el-form-item>
			</div>
			<el-popover placement="right" :width="'176'" trigger="click" v-if="$qiniu != null && salesMan != null">
				<div v-if="salesMan.wechatQRCode != ''">
					<img :src="$qiniu.domain + salesMan.wechatQRCode" style="width: 150px;height: 150px;display: block;">
					<span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{salesMan.userName}}</span>
					<span style="display: block;color: teal;width: 150px;text-align: center;">{{salesMan.contacts}}</span>          
				</div>
				<div style="display: flex; height: 26px; cursor: pointer;" slot="reference" v-if="salesMan != null">
					<font-awesome-icon :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69); font-size: 22px;" />
					<span style="color: rgb(42,161,69);font-size: 18px; font-weight: bold;">{{'业务:' + salesMan.userName}}</span>			
				</div>									
			</el-popover>
		</div>
		<div style="display: flex; flex-wrap: wrap;">
			<el-form-item label="特殊物品：" class="option">
				<el-checkbox-group v-model="form.specialGoodsNamelist" @change="changSpecialGoodsName">
					<el-checkbox v-for="item in specialGoodsNameOptions" :key="item" :label="item" ></el-checkbox>
				</el-checkbox-group>      
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="渠道特性：" class="option">
				<el-checkbox :true-label='1' :false-label='0' v-model="form.inputBillQuote">自打单</el-checkbox>
				<el-checkbox :true-label='1' :false-label='0' v-model="form.canBatteryInside">内电</el-checkbox>
				<el-checkbox :true-label='1' :false-label='0' v-model="form.canBatteryWith">外电</el-checkbox>
				<el-checkbox :true-label='1' :false-label='0' v-model="form.canBatteryAll">纯电</el-checkbox>
				<el-checkbox :true-label='1' :false-label='0' v-model="form.canDeclare">报关</el-checkbox>
			</el-form-item>	  
			<el-form-item class="option">
				<el-button type="primary" icon="el-icon-search" @click="tableloading?cancel():submitForm()">{{tableloading?'取消':'查询'}}</el-button>
				<el-button icon="el-icon-refresh" @click="resetForm">重 置</el-button>
			</el-form-item>    			
		</div>
		<div v-if="false" style="display: flex;">
<!-- 			<el-form-item label=" " prop="goodsType">
				<el-radio-group v-model="form.goodsType">
				  <el-radio :label="1">包裹</el-radio>
				  <el-radio :label="3">PAK袋</el-radio>
				  <el-radio :label="2">文件</el-radio>
				</el-radio-group>
			</el-form-item> -->
			<div v-if="form.volumeDiv || form.valueDeclared || form.bizType.length || form.serviceType || (form.scanDetails && (form.scanDetails.length > 0))" @click="diaparams = !diaparams" class="diaoption">
				<label v-if="form.volumeDiv">体积除(以上):{{form.volumeDiv}}</label>
				<label v-if="form.valueDeclared">申报价值:{{form.valueDeclared}}</label>
				<label v-if="form.bizType.length">业务类型:{{form.bizType.toString()}}</label>
				<label v-if="form.serviceType">服务类型:{{form.serviceType}}</label>
				<label v-if="form.scanDetails && (form.scanDetails.length > 0)">结算重:按尺寸</label>
			</div>			

			<el-form-item class="option">
				<el-button type="primary" icon="el-icon-search" @click="tableloading?cancel():submitForm()">{{tableloading?'取消':'查询'}}</el-button>
				<el-button icon="el-icon-refresh" @click="resetForm">重 置</el-button>
			</el-form-item>      
		</div>
<!-- 		<div style="display: flex;">
			<el-form-item label="特殊产品" v-if='specialGoodsNameOptions.length' prop="specialGoodsName">
				<el-select v-model="form.specialGoodsNamelist" filterable default-first-option multiple clearable collapse-tags @change="changSpecialGoodsName" placeholder="请选择特殊产品">
				  <el-option v-for="item in specialGoodsNameOptions" :key="item" :label="item" :value="item">
				  </el-option>
				</el-select>
			</el-form-item>
			<div @click="diaparams = !diaparams" class="diaoption">
				<label v-if="form.volumeDiv">体积除(以上):{{form.volumeDiv}}</label>
				<label v-if="form.valueDeclared">申报价值:{{form.valueDeclared}}</label>
				<label v-if="form.bizType.length">业务类型:{{form.bizType.toString()}}</label>
				<label v-if="form.serviceType">服务类型:{{form.serviceType}}</label>
				<label v-if="form.postCode">邮编:{{form.postCode}}</label>
				<label v-if="form.cityName">城市:{{form.cityName}}</label>
				<label v-if="!(form.volumeDiv || form.valueDeclared || form.bizType.length || form.serviceType || form.postCode || form.cityName)">更多</label>
			</div>
			<el-form-item class="option">
				<el-button type="primary" icon="el-icon-search" @click="tableloading?cancel():submitForm()">{{tableloading?'取消':'查询'}}</el-button>
				<el-button icon="el-icon-refresh" @click="resetForm">重 置</el-button>
			</el-form-item>
		</div> -->
      <el-dialog :visible.sync="diaparams">
<!--        <el-form-item label="体积除(以上)" prop="volumeDiv" clearable label-width="120px">
          <el-input v-model.number="form.volumeDiv" type='number' onKeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))" clearable placeholder="请录入价格"></el-input>
        </el-form-item>
        <el-form-item label="申报价值" prop="valueDeclared" clearable label-width="120px">
          <el-input v-model.number="form.valueDeclared" type="number" onkeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))" clearable placeholder="请录入价格"></el-input>
        </el-form-item>
        <br />
        <el-form-item label="业务类型" prop="bizType" clearable label-width="120px">
          <el-cascader v-model="form.bizType" @change='bizTypeChange' :options="biztypeOptions" :props="{ multiple: true ,label:'value',emitPath:false }" :emitPath="false" collapse-tags clearable placeholder="请选择业务类型"></el-cascader>
        </el-form-item>
        <el-form-item label="服务类型" prop="serviceType" clearable label-width="120px">
          <el-select v-model="form.serviceType" :disabled="form.bizType.length != 1">
            <el-option v-for="item in serviceTypeOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
		
        <el-form-item label="邮编" prop="postCode" label-width="120px">
          <el-select v-model="form.postCode" :disabled="!form.countryCode" filterable default-first-option remote :remote-method="remoteMethodPostCode" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择邮编'">
            <el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市" prop="cityName" label-width="120px">
          <el-select v-model="form.cityName" :disabled="!form.countryCode" filterable default-first-option remote :remote-method="remoteMethodCityName" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择城市'">
            <el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <br /> 		
        <el-alert show-icon title="尺寸明细只做加收限制判断，不做计费重量" type="warning" :closable="false" style="background-color: white;width: 100%;height: 30px;line-height: 30px;color: #e6a23c; font-size: 13px;padding:0;"></el-alert>
-->		
        <el-input type="textarea" :rows="8" style="margin-top: 10px;"
           v-model="scanDetailText" :placeholder="sizePlaceHolder"></el-input>   		
        <div class="dialog-footer" style="display: flex; flex-direction: rows; justify-content: flex-end; margin: 10px 0px;">
          <el-button @click="mmFillSize">毫米转厘米填入</el-button>
          <el-button type="primary" @click="cmFillSize">填入</el-button>
        </div>
        <vxe-table border show-overflow keep-source ref="xTable" max-height="400" :data="tableScanDetails" :mouse-config="{selected: true}" :keyboard-config="{isArray: true, isTab: true, isEdit: true}" :edit-config="{trigger: 'click', mode: 'cell'}">
          <vxe-table-column field="realWeight" title="单件实重" :edit-render="{name: '$input',  props: {type: 'number', placeholder: '请输入单件实重'}}"></vxe-table-column>
          <vxe-table-column field="len" title="长" :edit-render="{name: '$input', props: {type: 'number', placeholder: '请输入长'}}"></vxe-table-column>
          <vxe-table-column field="width" title="宽" :edit-render="{name: '$input', props: {type: 'number', placeholder: '请输入宽'}}"></vxe-table-column>
          <vxe-table-column field="height" title="高" :edit-render="{name: '$input', props: {type: 'number', placeholder: '请输入高'}}"></vxe-table-column>
          <vxe-table-column field="caseCount" title="件数" :edit-render="{name: '$input', defaultValue: 1, props: {type: 'number', placeholder: '请输入件数'}}"></vxe-table-column>
          <vxe-table-column field="packageType" title="包装类型" :formatter="formatpackTypeLabel" :edit-render="{name: '$select', defaultValue: 1, props: {options:packageType,type: 'number', placeholder: '请输入包装类型'}}"></vxe-table-column>		  
          <vxe-table-column title="操作" width="100" show-overflow>
            <template #header>
				<el-button icon="el-icon-plus" @click="insertEvent()">新增</el-button>
            </template>
            <template #default="{ row }">
				<el-button type="text" icon="el-icon-close" @click="removeEvent(row)"></el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetFormdia">重 置</el-button>
          <el-button type="primary" @click="okFormdia">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="报价最近更新" :visible.sync="dialgpri">
        <el-table :data="customerquote">
          <el-table-column property="lastUpdateTime" label="更新时间"></el-table-column>
          <el-table-column property="customerQuoteName" label="报价名"></el-table-column>
          <el-table-column property="lastCustomerContent" label="更新内容"></el-table-column>
        </el-table>
      </el-dialog>
      <div v-if='tableData.length' style="margin-bottom: 10px;">
			<el-form-item>
				<el-select v-model="tableSortFilter.orderBy">
					<el-option v-for="(item, k) in tableSortOptions" :label="item.label" :value="item.value" :key="k"></el-option>
				</el-select>
			</el-form-item>		  
			<el-form-item>
				<el-select v-model="tableSortFilter.battery">
					<el-option v-for="(item, i) in tableBatteryFilterOptions" :key="i" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>		  
			<el-form-item>
				<el-select v-model="tableSortFilter.bizType" placeholder="全部渠道" clearable class="biztype-select">
					<el-option v-for="(item, i) in tableBizTypeFilterOptions" :key="i" :label="item.label" :value="item.value"></el-option>
					<template slot="empty">没有选项</template>					
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-checkbox v-model="tableSortFilter.specialGoods" :true-label='1' :false-label='0'>{{tableSpecialGoodsLabel}}</el-checkbox>
			</el-form-item>      
			<!-- <el-button v-if="tableData.filter(e=>e.providerSpecialGoods).length" :type="searchType == 'providerSpecialGoods' ?'primary':''" :style="searchType == 'providerSpecialGoods'?'':'color:red;'" style="margin-left: 15px;" @click="searchType = 'providerSpecialGoods'">特殊产品<span style="margin-left: 5px;">{{tableData.filter(e=>e.providerSpecialGoods).length}}</span></el-button>			 -->
<!-- 			<el-radio-group v-model="quoteCountLabel" size="small" v-if="quoteCountList.length > 0" @change="quoteCountItemChanged" style="margin-left: 30px;">
			  <el-radio-button v-for="(item, k) in quoteCountList" :key="k" :label="getQuoteCountLabel(item)"></el-radio-button>
			</el-radio-group> -->
<!--        <el-button :type="sortval == 1 ?'primary':''" @click="sortval = 1">价格排序<i class="el-icon-bottom"></i></el-button>
        <el-button :type="sortval == 2 ?'primary':''" @click="sortval = 2" style="margin-left: 15px;">时效排序<i class="el-icon-bottom"></i></el-button>
        <el-button :type="sortval == 3 ?'primary':''" @click="sortval = 3" style="margin-left: 15px;">推荐<i class="el-icon-bottom"></i></el-button> -->
 <!--       <el-button :type="searchType == '' ?'primary':''" @click="searchType = ''" style="margin-left: 40px;">全部</el-button>
        <el-button v-if="tableData.filter(e=>e.canBatteryInside).length" :type="searchType == 'canBatteryInside' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryInside'">接内电<span style="margin-left: 5px;">{{tableData.filter(e=>e.canBatteryInside).length}}</span></el-button>
        <el-button v-if="tableData.filter(e=>e.canBatteryWith).length" :type="searchType == 'canBatteryWith' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryWith'">接外电<span style="margin-left: 5px;">{{tableData.filter(e=>e.canBatteryWith).length}}</span></el-button>
        <el-button v-if="tableData.filter(e=>e.canBatteryAll).length" :type="searchType == 'canBatteryAll' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryAll'">接内电<span style="margin-left: 5px;">{{tableData.filter(e=>e.canBatteryAll).length}}</span></el-button>
        <el-button v-if="tableData.filter(e=>e.canDeclare).length" :type="searchType == 'canDeclare' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canDeclare'">接外电<span style="margin-left: 5px;">{{tableData.filter(e=>e.canDeclare).length}}</span></el-button>
 -->        <!-- <el-badge v-if="tableData.filter(e=>e.canBatteryInside).length" :value="tableData.filter(e=>e.canBatteryInside).length">
          <el-button :type="searchType == 'canBatteryInside' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryInside'">接内电</el-button>
        </el-badge>
        <el-badge v-if="tableData.filter(e=>e.canBatteryWith).length" :value="tableData.filter(e=>e.canBatteryWith).length">
          <el-button :type="searchType == 'canBatteryWith' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryWith'">接外电</el-button>
        </el-badge>
        <el-badge v-if="tableData.filter(e=>e.canBatteryAll).length" :value="tableData.filter(e=>e.canBatteryAll).length">
          <el-button :type="searchType == 'canBatteryAll' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canBatteryAll'">接纯电</el-button>
        </el-badge>
        <el-badge v-if="tableData.filter(e=>e.canDeclare).length" :value="tableData.filter(e=>e.canDeclare).length">
          <el-button :type="searchType == 'canDeclare' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'canDeclare'">接报关</el-button>
        </el-badge> -->
        <!-- <el-badge v-if="tableData.filter(e=>e.providerSpecialGoods).length" :value="tableData.filter(e=>e.providerSpecialGoods).length">
          <el-button :type="searchType == 'providerSpecialGoods' ?'primary':''" style="margin-left: 15px;" @click="searchType = 'providerSpecialGoods'">特殊产品</el-button>
        </el-badge> -->
      </div>
<!--      <div v-if='tableData.length' style="margin-bottom: 10px;">
        <el-button :type="tableSearch == '' ?'primary':''" @click="tableSearch = ''">全部</el-button>
        <template v-for="(bizGroup,i) in biztypeOptions">
          <template v-for="(item,y) in bizGroup.children">
            <el-button v-if="tableData.filter(e=>(e.bizType == item.name)).length" :key="i+'*'+y" :type="tableSearch == item.name ?'primary':''" style="margin-left: 15px;" @click="tableSearch = item.name">
              {{item.name}}<span style="margin-left: 5px;">{{tableData.filter(e=>(e.bizType == item.name)).length}}</span>
            </el-button>
          </template>
        </template>
      </div> -->
    </el-form>
    <div style="display: flex;">
        <div>
          <el-alert v-if="countryremk" show-icon :title="countryremk" type="warning" :closable="false" style="background-color: white;width: 100%; height: 30px;line-height: 30px;color: #e6a23c; font-size: 13px;padding:0;"></el-alert>
        </div>
        <div style="flex:1;">
<!--          <el-alert style="color: #FF33CC; background-color: #FFFFCC; width: 100%;"
            title="报关，带电，特别产品的附加费，需要勾选后再查询，系统才会计算在总价里"
            type="success"
            :closable="false">
          </el-alert> -->
			<a :href="providerAppSetting.priceServiceUrl" target="_blank">{{providerAppSetting.priceServiceRemark}}</a>
        </div>
    </div>	
    <el-table :data="tableSearchData" @row-click="rowClick" border ref="refTable" v-loading="tableloading" style="flex:1;overflow: auto;" height='auto'>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-button @click="goDelivery(scope.row,form)" style="color:blue !important">
            <font-awesome-icon :icon="['fas', 'hand-point-right']" />发货预报
          </el-button>
          <div v-if="scope.row.providerQuoteAttachment && scope.row.providerQuoteAttachment.length">
            <span>附件下载:</span>
            <a style="margin-left: 10px;" v-for="(quoteAttachment, i) in JSON.parse(scope.row.providerQuoteAttachment)" :key="i" :href="quoteAttachment.url" :download="quoteAttachment.name">【{{quoteAttachment.name}}】</a>
          </div>
          <template v-if='scope.row.addFeeObjList && scope.row.addFeeObjList.length'>
            <div>加收限制:</div>
            <div v-for="(addFeeObj, i) in scope.row.addFeeObjList" :key="i" style="display: flex;">
              <i class="el-icon-circle-check" style="color: red;margin-right: 10px;line-height: 32px;" v-if='addFeeObj.conditionMatched && addFeeObj.calcResult == 0'></i>
              <i class="el-icon-circle-check" style="color: transparent;margin-right: 10px;" v-else></i>
              <div>
                <el-button type="text" style="color:#0099ff;margin-right:20px;">
                  <template v-if="addFeeObj.feeType == 5">提示</template>
                  {{ addFeeObj.ruleRemark }}<template v-if="addFeeObj.ruleRemark">：</template><template v-if='addFeeObj.feeType == 1'>加收 </template>{{addFeeObj.actionDesc}}
                </el-button>条件：{{addFeeObj.conditionDesc}}
              </div>
            </div>
            <el-divider></el-divider>
          </template>
          <div v-if="scope.row.weightCalcRuleMultiPieces != 'undefined' || scope.row.serviceType || scope.row.volumeDiv">
            <span v-if='scope.row.serviceType'>服务类型:{{scope.row.serviceType}}</span>
            <span v-if='scope.row.volumeDiv'>体积除:{{scope.row.volumeDiv}}</span>
            <span v-if="scope.row.weightCalcRuleMultiPieces != 'undefined'">多件重量计算方式:{{scope.row.weightCalcRuleMultiPieces == 0 ? '按票' : scope.row.weightCalcRuleMultiPieces == 1 ? '按件0.5进位' : '按件不进位'}}</span>
            <el-divider></el-divider>
          </div>
          <template v-if='scope.row.disaddZoneRemark'>
            <div>折扣加收分区备注:</div>
            <div>{{ scope.row.disaddZoneRemark }}</div>
            <el-divider></el-divider>
          </template>
          <template v-if='scope.row.zoneRemark'>
            <div>分区备注:</div>
            <div>{{ scope.row.zoneRemark }}</div>
            <el-divider></el-divider>
          </template>
          <template v-if='scope.row.disaddRemark'>
            <div>折扣加收备注:</div>
            <div>{{ scope.row.disaddRemark }}</div>
            <el-divider></el-divider>
          </template>
          <template>
            <div>报价备注:</div>
            <div style="white-space: pre-line;">{{ scope.row.quoteRemark }}</div>
            <el-divider></el-divider>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="providerName" label="预报" min-width="7%">
        <template slot-scope="scope">
          <div style="font-size: 13px; font-weight: bold;">
			  <el-button icon="el-icon-edit-outline" type="text" @click.stop="goDelivery(scope.row,form)">预报</el-button>
				<!-- {{getSpName(scope.row)}}			 -->
          </div>
          <el-popover v-if="scope.row.bizTypeUserName" placement="right" :width="'176'" trigger="hover">
            <div v-if="scope.row.bizTypeUserWechatQRCode">
              <img :src="$qiniu.domain + scope.row.bizTypeUserWechatQRCode" style="width: 150px;height: 150px;display: block;">
              <span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{scope.row.bizTypeUserName}}</span>
              <span style="display: block;color: teal;width: 150px;text-align: center;">{{scope.row.bizTypeUserContacts}}</span>                   
            </div>
            <font slot="reference" style="color: rgb(42, 161, 69); cursor: pointer;color: rgb(42, 161, 69);cursor: pointer;position: absolute;right: 5px;bottom: 0;"><span>{{scope.row.bizTypeUserName}}</span></font>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="渠道" min-width="15%">
        <template slot-scope="scope">
          <div>
            <!-- <el-button type="text" @click.stop="goquotedetails(scope.row)">{{scope.row.providerQuoteName}}</el-button> -->
			 <el-link type="primary" @click.stop="goquotedetails(scope.row)">{{scope.row.providerQuoteName}}</el-link>
          </div>
          <el-tag type="info" style='position: absolute;bottom: 0;right: 0;' v-if="scope.row.bizType || scope.row.serviceType">
            <template v-if="scope.row.bizType">{{scope.row.bizType}}</template>
            <template v-if="scope.row.bizType && scope.row.serviceType">-</template>
            <template v-if="scope.row.serviceType">{{scope.row.serviceType}}</template>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="destination" label="目的地" min-width="10%"></el-table-column>
      <el-table-column prop="weight" label="结算重量" min-width="7%"></el-table-column>
      <el-table-column prop="price" label="单价" min-width="7%"></el-table-column>
      <el-table-column prop="amount" label="总价" min-width="7%"></el-table-column>
      <el-table-column label="特别说明" min-width="24%">
        <template slot-scope="scope">
          <div>
            <template>
              <span>可接:</span>
              <template v-if="scope.row.providerSpecialGoods">
                <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-for="(item,k) in scope.row.providerSpecialGoods.split(';')" :key='k'>{{item}}</el-tag>
              </template>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.canDeclare">报关</el-tag>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.canBatteryInside">内电</el-tag>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.canBatteryWith">外电</el-tag>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.canBatteryAll">纯电</el-tag>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.inputBillQuote">{{scope.row.inputBillQuote==1?'制单':'预报'}}</el-tag>
              <el-tag color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark" v-if="scope.row.cargoChannel">大货通道</el-tag>
            </template>
            <template v-if="scope.row.recentPickupMinutes || scope.row.arrivePeriodDays">
              <template v-if="scope.row.recentPickupMinutes>0">
                <el-tag v-if='scope.row.recentPickupMinutes/60/24<0.8' color="#00cc66" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">当天提取
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收</template>
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
                </el-tag>
                <el-tag v-else-if='scope.row.recentPickupMinutes/60/24<2' color="#0099ff" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">次日提取
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收</template>
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
                </el-tag>
                <el-tag v-else-if='scope.row.recentPickupMinutes/60/24<3' color="#ffcc00" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">2-3天提取
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收</template>
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
                </el-tag>
                <el-tag v-else color="#ff6600" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">{{parseInt(scope.row.recentPickupMinutes/60/24)}}-{{parseInt(scope.row.recentPickupMinutes/60/24)+1}}天提取
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收</template>
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
                </el-tag>
              </template>
              <template v-else-if="scope.row.recentPickupMinutes<0">
                <el-tag color="#bcbcbc" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">{{parseInt(Math.abs(scope.row.recentPickupMinutes)/60/24)}}-{{parseInt(Math.abs(scope.row.recentPickupMinutes)/60/24)+1}}天未提取
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收</template>
                  <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
                </el-tag>
              </template>
              <el-tag v-else color="#bcbcbc" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">？天提取
                <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays) == 0">+{{scope.row.signPeriodDays}}天签收{{scope.row.destination}}</template>
                <template v-if="scope.row.signPeriodDays && parseInt(scope.row.signPeriodDays)>0">+<span :style="scope.row.signPeriodDays>3?'color:red':''">{{parseInt(scope.row.signPeriodDays)}}-{{parseInt(scope.row.signPeriodDays)+1}}天签收</span></template>
              </el-tag>
            </template>
            <el-tag v-else-if='scope.row.notPickupPeriodMinutes' :color="scope.row.notPickupPeriodMinutes/60/24>=4?'#ff6600':scope.row.notPickupPeriodMinutes/60/24>=3?'#ffcc00':scope.row.notPickupPeriodMinutes/60/24>=1?'#0099ff':'#00cc66'" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">提取超{{ (scope.row.notPickupPeriodMinutes/60/24).toFixed(1) }}天</el-tag>
            <el-tag v-if="scope.row.exportPeriodMinutes" color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">出口{{ (scope.row.exportPeriodMinutes/60/24).toFixed(1) }}天</el-tag>
            <el-tag v-else-if='scope.row.notExportPeriodMinutes' color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">出口超{{ (scope.row.notExportPeriodMinutes/60/24).toFixed(1) }}天</el-tag>
            <el-tag v-if="scope.row.arrivePeriodMinutes" color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">到港{{ (scope.row.arrivePeriodMinutes/60/24).toFixed(1) }}天</el-tag>
            <el-tag v-else-if='scope.row.notArrivePeriodMinutes' color="#0c6" style="border-color: transparent;margin-left: 2px;border-radius: 0;" effect="dark">到港超{{ (scope.row.notArrivePeriodMinutes/60/24).toFixed(1) }}天</el-tag>
          </div>
          <div v-if="scope.row.providerSpecialRemark">{{scope.row.providerSpecialRemark}}</div>
          <div style="margin-right: 10px;" v-if="scope.row.zoneRemark">{{scope.row.zoneRemark}}</div>
          <template v-if='scope.row.customerServiceRemark'>
            <div style="margin-right: 10px;">{{ scope.row.customerServiceRemark }}</div>
          </template>
          <template v-if='scope.row.addFeeObjList && scope.row.addFeeObjList.length'>
            <template v-for="(addFeeObj, i) in scope.row.addFeeObjList" style="display: flex;">
              <div :key="i" v-if="addFeeObj.conditionMatched && addFeeObj.calcResult == 0 && addFeeObj.feeType == 5">
                <div style="color:teal;margin-right:20px;">
                  {{ addFeeObj.ruleRemark }}<template v-if="addFeeObj.ruleRemark">：</template>{{addFeeObj.actionDesc}}
                </div>
                <!-- <el-button type="text" style="color:#0099ff;margin-right:20px;">
                  {{ addFeeObj.ruleRemark }}<template v-if="addFeeObj.ruleRemark">：</template>{{addFeeObj.actionDesc}}
                </el-button> -->
              </div>
            </template>
          </template>
          <div v-if="scope.row.recommend === 1" style="color: #0099FF;font-size: 10px;line-height: 12px;color: rgb(0,204,102);overflow: hidden;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">
            <svg style="vertical-align: bottom;width: 20px;height: 20px;transform: rotateY(180deg);color:#0099FF;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="thumbs-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-thumbs-up fa-w-16 fa-3x">
              <path fill="currentColor" d="M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z" class=""></path>
            </svg>
            {{scope.row.recommendRemark}}
          </div>
<!--          <div style="display: flex;justify-content: end;">
            <span v-if='scope.row.lastUpdateTime' style="margin-right: 10px;color: gray;">{{scope.row.lastUpdateTime.substring(5,16)+'更新'}}</span>
            <el-popover v-if="scope.row.salesManWechatQRCode || scope.row.salesManQQ" placement="right" :width="scope.row.salesManWechatQRCode && scope.row.salesManQQ?'326':'176'" trigger="click">
              <div v-if="scope.row.salesManWechatQRCode">
                <img :src="$qiniu.domain + scope.row.salesManWechatQRCode" style="width: 150px;height: 150px;display: block;">
                <span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{scope.row.salesManName}}</span>
              </div>
              <div v-if="scope.row.salesManQQ">
                <a :href="'tencent://message/?Site=baidu.com&uin='+scope.row.salesManQQ+'&Menu=yes'">
                  <svg style="width: 150px;height: 150px;display: block;" t="1610534181528" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2548" width="200" height="200">
                    <path d="M109.7 0h804.5C974.8 0 1024 49.1 1024 109.7v804.5c0 60.5-49.1 109.7-109.7 109.7H109.7C49.2 1024 0 974.9 0 914.3V109.7C0 49.2 49.2 0 109.7 0z" fill="#FFFFFF" p-id="2549"></path>
                    <path d="M619.3 720.3c-57.7-2.7-105.7 16.8-107.2 43.6-1.5-26.8-49.5-46.3-107.3-43.6-57.9 2.7-103.7 26.7-102.4 53.6 1.3 26.9 49.5 46.5 107.3 43.7 56.1-2.7 100.8-25.2 102.4-50.9 1.6 25.9 46.3 48.4 102.4 50.9 57.9 2.7 105.9-16.9 107.3-43.7 1.3-27-44.6-50.8-102.5-53.6" fill="#FFAA00" p-id="2550"></path>
                    <path d="M619.3 720.3c-57.7-2.7-105.7 16.8-107.2 43.6-1.5-26.8-49.5-46.3-107.3-43.6-57.9 2.7-103.7 26.7-102.4 53.6 1.3 26.9 49.5 46.5 107.3 43.7 56.1-2.7 100.8-25.2 102.4-50.9 1.6 25.9 46.3 48.4 102.4 50.9 57.9 2.7 105.9-16.9 107.3-43.7 1.3-27-44.6-50.8-102.5-53.6" fill="#FFAA00" p-id="2551"></path>
                    <path d="M330.8 441.5c0 4.1-5.6 7.5-12.4 7.5-6.9 0-12.4-3.3-12.4-7.5 0-4.1 5.6-7.5 12.4-7.5 6.8 0 12.4 3.3 12.4 7.5" fill="" p-id="2552"></path>
                    <path d="M716.1 441.5c0 4.1-5.6 7.5-12.4 7.5s-12.4-3.3-12.4-7.5c0-4.1 5.6-7.5 12.4-7.5s12.4 3.3 12.4 7.5" fill="#53564E" p-id="2553"></path>
                    <path d="M705.1 473.1c-1.5 4-2.8 8-3.9 11.9-34.1-73.2-106.5-123.9-190.3-123.9-83.5 0-155.5 50.1-189.9 122.9-1.1-3.7-2.3-7.3-3.6-11.1 0 0-103.5 105.6-56.3 205.7 7.2 14.1 29.5-4.4 46.7-40.3 25.2 88 107.5 140.3 204.3 140.3 97.1 0 178-53.1 202.4-141.3 17.6 36.7 40.7 55.7 48.1 41.5 48.1-100.1-57.5-205.7-57.5-205.7" fill="" p-id="2554"></path>
                    <path d="M343.5 594.9c0 99.3 65.3 175.5 165.3 175.5s164.7-76.1 164.7-175.5c0-94.7-71.3-166.8-164.9-166.8-93.8 0-165.1 72.2-165.1 166.8" fill="#FFFFFF" p-id="2555"></path>
                    <path d="M710.8 411.3c-3.2 109.7-33.7 136-199.6 136s-200.4-26.3-200.4-136c0-119.9 89.5-206.1 200-206.1s203.1 98.5 200 206.1" fill="" p-id="2556"></path>
                    <path d="M596.9 474.8c-42.5 22.9-54.3 34.9-87.7 36.1-33.5 1.2-45.2-13.3-87.7-36.1-66.8-36-37.1-38.9 5.5-52.1 25.2-7.7 59.9-11.6 82.3-11.6 22.3 0 57.1 3.9 82.3 11.6 42.4 13 72.1 16.1 5.3 52.1" fill="#FFAA00" p-id="2557"></path>
                    <path d="M610.5 442.5s-12.9 19.6-48.3 33.5c-18.5 7.3-26.1 24-53.1 24-26.9 0-34.7-16.5-53.1-24-34.8-13.9-48.3-33.5-48.3-33.5 7.9 6.3 38.5 36.3 100.8 36.3 62.4-0.1 94.2-30.1 102-36.3" fill="#AC2B28" p-id="2558"></path>
                    <path d="M417.3 353.7c-1.1-29.7 14.7-54.7 35.3-55.6 20.7-0.9 38.3 22.4 39.3 52.3 1.1 29.7-14.7 54.7-35.3 55.6-20.6 0.8-38.2-22.5-39.3-52.3M523.6 353.2c0-29.7 16.7-53.7 37.3-53.7 20.5 0 37.3 24.1 37.3 53.7 0 29.7-16.7 53.7-37.3 53.7-20.5 0-37.3-24.1-37.3-53.7" fill="#FFFFFF" p-id="2559"></path>
                    <path d="M571.2 367.3c-2.7 0-4.8-2.1-4.8-4.8v-1.1c0-12.5-4.8-22.3-10.9-22.3-6.1 0-10.9 9.7-10.9 22.3v1.1c0 2.7-2.1 4.8-4.8 4.8s-4.8-2.1-4.8-4.8v-1.1c0-18.8 8.4-32 20.5-32s20.5 13.2 20.5 32v1.1c0 2.7-2.1 4.8-4.8 4.8M482.1 348.7c0.9 13.9-5.7 26.1-15.1 27.5-9.3 1.3-17.6-8.8-18.5-22.5-0.9-13.9 5.7-26.1 15.1-27.5 9.2-1.4 17.5 8.7 18.5 22.5" fill="#53564E" p-id="2560"></path>
                    <path d="M475.3 347.9c0.1 4.7-2.4 8.5-5.7 8.8-3.3 0.3-6.1-3.2-6.3-7.9-0.1-4.7 2.4-8.5 5.7-8.8 3.4-0.3 6.2 3.3 6.3 7.9" fill="#FFFFFF" p-id="2561"></path>
                    <path d="M718.3 448c-1.6-7.3-2.5-10.4-5.7-11.9-0.5 1.2-1.3 2.5-2.3 4-13.7 21.5-77.6 80-199.3 80.8-121.7-0.7-185.6-59.2-199.3-80.8-0.9-1.5-1.6-2.8-2.3-4-3.2 1.5-4.1 4.5-5.7 11.9-9.2 43.6-11.1 51.6-10.9 51.7 6 9.1 16.1 18.7 29.5 27.9 14.8 10.7 32.3 19.9 51.6 27.6-3.2 17.1-6.5 42.4-6.5 72 0 9.9 0.8 12.5 4.8 16.8 9.6 10.3 46.5 14.8 62.3 14.4 6.3-0.1 12-4.4 12-11.6 0-16.3-0.1-48.3-0.1-71.2 20.1 3.6 41.2 5.7 62.5 5.7h4.6c29.7 0 58.9-4.1 86-10.8 38.5-9.2 74-23.9 100.5-43.1 13.3-9.2 23.5-18.8 29.5-27.9-0.3 0.1-3.9-17-11.2-51.5" fill="#E32B10" p-id="2562"></path>
                  </svg>
                </a>
                <span style="display: block;color: teal;width: 150px;text-align: center;">QQ联系：{{scope.row.salesManName}}</span>
              </div>
              <font slot="reference" style="color: rgb(42, 161, 69); cursor: pointer;">{{scope.row.salesManName}}</font>
            </el-popover>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="30%">
        <template slot-scope="scope">
          <div v-if="scope.row.freight || scope.row.formula">
            <span style="margin-right: 10px;">运费:{{scope.row.freight}}</span>
            计算公式:{{scope.row.formula}}
          </div>
          <div v-if="scope.row.freightConditionAdd || scope.row.addFeeObjList">
            <span style="margin-right: 10px;">附加费:{{scope.row.freightConditionAdd}}</span>
            说明:
            <template v-for="(addFeeObj) in scope.row.addFeeObjList">
              <template v-if="addFeeObj.conditionMatched && addFeeObj.calcResult == 0">{{addFeeObj.ruleRemark}}:{{addFeeObj.addFee}}</template>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Vue from 'vue'
import * as string from '@/utils/string'
export default {
  name: 'Price',
  data() {
    return {
      providerservicestaff: [], // 联系人
      countryOptions: [], // 目的地
      countryOptionsCrror: [], // 目的地过滤后
      //customerOptions: [], // 服务商
      //customerOptionsCrror: [], // 服务商过滤后
      providerList: [],	  
      filteredProviders: [],
      providerOptions: [], //服务商级联选择options
      biztypeOptions: [], // 业务类型
      serviceTypeOptions: [], // 服务类型
      countrycityOptions: [], // 邮编或城市
      specialGoodsNameOptions: [], // 特殊产品
      salesMan: null,
      quoteCountList: [],
      quoteCountLabel: '',	 	
	  sizeVisible: false,
      form: {
        countryCode: '',
        weight: '',
		weightText: '',
        goodsType: 1,
        inputBillQuote: 0,
        canBatteryInside: 0,
        canBatteryWith: 0,
        canBatteryAll: 0,
        canDeclare: 0,
        providerDepartment: [],
        departmentName: '',
        volumeDiv: '',
        valueDeclared: '',
        serviceType: '',
        bizType: [],
        postCode: '',
        cityName: '',
        scanDetails: [],
        specialGoodsNamelist: [],
        specialGoodsName: ''
      },
	  scanDetailText: '',
	  tableScanDetails: [],
      rules: {
        countryCode: [{ required: true, message: '目的地不能为空', trigger: 'change' }],
		weightText: [{ required: true, message: '重量不能为空', trigger: 'change' }]
        // weight: [
        //   { required: true, message: '重量不能为空', trigger: 'change' },
        //   { type: 'number', message: '请录入数字', trigger: 'change' }
        // ]
      },   
		providerAppSetting: {
		  priceServiceRemark: ''  
		},
      dialgpri: false,
      diaparams: false,
      diaoplist: false,
      customerquote: [],
      tableloading: false,
      tableData: [],
      tableSearch: '',
      searchType: '',
      updatechartkey: Math.random(),
      packageType: [
        {
          value: 1,
          label: '纸箱'
        },
        {
          value: 2,
          label: '木箱'
        },
        {
          value: 3,
          label: '航空箱'
        },
        {
          value: 4,
          label: '木架'
        },
        {
          value: 5,
          label: '托盘'
        },
        {
          value: 6,
          label: '袋或膜'
        },
        {
          value: 7,
          label: '其它'
        }
      ],
      goodsTypeOptions: [
				{value:1, label: '包裹'},
				{value:3, label: 'PAK袋'},
				{value:2, label: '文件'}        
      ],
      tableSortFilter:{
        orderBy: 1,
        battery: 0,
        bizType: '',
        specialGoods: 0
      },      
      tableSortOptions: [
        {label:"价格排序↓", value:1},
        {label:"时效排序↓", value:2},
        {label:"推荐↓", value:3}
      ],
      tableBatteryFilterOptions: [
        {label:"电池报关(不限)", value:0},
        {label:"接内电", value:1},
        {label:"接外电", value:2},
        {label:"接纯电", value:3},
        {label:"接报关", value:4}
      ],
      tableSpecialGoodsLabel: '接特殊物品',
      tableBizTypeFilterOptions: [],
	  sizePlaceHolder: '输入格式:\n75.5KG 157 40 40 2件\n75.5 157 40 40 (默认1件)\n75.5 157 40 40 2 (第1和第5个数取小的做件数)'
    }
  },
  computed: {
    tableSearchData() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.updatechartkey = Math.random()
      let tabledata = this.tableData
      if (this.tableSortFilter.orderBy == 1) {
        tabledata.sort((a, b) => {
          if (a.amount < b.amount) return -1
          return 1
        })
      }
      if (this.tableSortFilter.orderBy == 2) {
        tabledata.sort((a, b) => {
          let aflog = a.recentPickupMinutes && a.recentPickupMinutes > 0
          let bflog = b.recentPickupMinutes && b.recentPickupMinutes > 0
          if (aflog && bflog) {
            return a.recentPickupMinutes < b.recentPickupMinutes ? -1 : 1
          } else if (aflog || bflog) {
            return aflog ? -1 : 1
          } else if (a.recentPickupMinutes && b.recentPickupMinutes) {
            return a.recentPickupMinutes > b.recentPickupMinutes ? -1 : 1
          } else if (a.recentPickupMinutes || b.recentPickupMinutes) {
            return a.recentPickupMinutes ? -1 : 1
          } else {
            return 1
          }
        })
      }
      if (this.tableSortFilter.orderBy == 3) {
        tabledata.sort((a, b) => {
          if (a.recommend == 1 && b.recommend != 1) return -1
          return 1
        })
      }
      if (this.tableSortFilter.bizType) {
        tabledata = tabledata.filter((options) => {
          return options['bizType'].toString().toLowerCase()==this.tableSortFilter.bizType.toLowerCase()
          //.indexOf(this.tableSortFilter.bizType.toLowerCase()) != -1
        })
      }
      if (this.tableSortFilter.battery) {
        switch(this.tableSortFilter.battery){
          case 1:
            tabledata = tabledata.filter((options) => {			
              return options['canBatteryInside']
            })
            break;
          case 2:
            tabledata = tabledata.filter((options) => {			
              return options['canBatteryWith']
            })
            break;
          case 3:
            tabledata = tabledata.filter((options) => {			
              return options['canBatteryAll']
            })
            break;
          case 4:
            tabledata = tabledata.filter((options) => {			
              return options['canDeclare']
            })
          }
      }
      if(this.tableSortFilter.specialGoods == 1){
          tabledata = tabledata.filter((options) => {			
            return options['providerSpecialGoods']
          })			
      }
      if(this.quoteCountLabel){
        let countItem = this.quoteCountList.find(item=>this.getQuoteCountLabel(item)==this.quoteCountLabel)
        if(countItem.providerName){
          tabledata = tabledata.filter((item)=>item.providerName==countItem.providerName&&item.salesManDepartName==countItem.providerDepartName)
        }
      }
      return tabledata
    },
    countryremk() {
      let text = ''
      if (this.form.countryCode) {
        let crror =
          this.countryOptions.filter((options) => {
            return options.countryCode == this.form.countryCode
          })[0] || {}
        let batteryLimit = crror.batteryLimit
        batteryLimit = batteryLimit.substring(batteryLimit.length - 1) == ',' ? batteryLimit.substring(0, batteryLimit.length - 1) : batteryLimit
        if (batteryLimit) {
          text = batteryLimit + '不接带电;'
        }
        text = text + (crror.remark || '')
        text = text ? '用户反馈参考:【' + crror.nameChinese + '】' + text : ''
      }
      return text
    }
  },
  watch: {
    'form.providerDepartment'() {
		this.getspecialGoodsNameOptions()
    }
  },
  async mounted() {
	Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期		  
    this.getBiztype()
    this.getcustomerquote()
    await this.getproviderlist()
    this.getproviderservicestaff()
    await this.getCountrylist()
    this.$refs['inputCountryCode'].focus()
  },
  methods: {
    async getproviderservicestaff() {
      this.providerservicestaff = await this.$api.providerservicestaff(this.form.providerCode)
    },
    findsalesMan(providerCode) {
      if (this.providerservicestaff.find((item) => item.providerInfo && item.providerInfo.tenantId == providerCode)) {
        return this.providerservicestaff.find((item) => item.providerInfo && item.providerInfo.tenantId == providerCode).salesMan
      }
    },
    getSpName(row){
      if(row.salesManDepartName){
        return row.salesManDepartName;
      }else{
        return row.providerName
      }
    },	
    changSpecialGoodsName() {
      this.form.specialGoodsName = this.form.specialGoodsNamelist.join(';')
    },
    quoteCountItemChanged(){
      let countItem = this.quoteCountList.find(item=>this.getQuoteCountLabel(item)==this.quoteCountLabel)
      if(countItem.providerCode){
        this.form.providerDepartment = [countItem.providerCode] 
        if(countItem.providerDepartName){
          this.form.providerDepartment.push(countItem.providerDepartName)
        }
        console.log(this.providerDepartment)			
      }else{
        this.form.providerDepartment = []
      }
    },
    countProviderQuotes(tableData){
      this.quoteCountList = []
      let total = 0
      if(tableData.length > 0){
        this.quoteCountList.push({providerCode: '', providerName: '', providerDepartName: '', quoteCount: 0})
        for(let i = 0, len = tableData.length; i < len; i++){
          total++
          let providerItem = this.quoteCountList.find((item)=>item.providerName==tableData[i].providerName && item.providerDepartName == tableData[i].salesManDepartName)
          if (typeof(providerItem) != "undefined"){
            providerItem.quoteCount++
          }else{
            this.quoteCountList.push({providerCode:tableData[i].providerCode, providerName: tableData[i].providerName, providerDepartName: tableData[i].salesManDepartName, quoteCount: 1})
          }
        }
        this.quoteCountList[0].quoteCount = total
        this.quoteCountLabel = this.getQuoteCountLabel(this.quoteCountList[0])
      }
    },	
    getQuoteCountLabel(item){
      if(item.providerDepartName){
        return item.providerDepartName + item.quoteCount
      }
      if(item.providerName){
        return item.providerName + item.quoteCount
      }
      return '全部' + item.quoteCount		
    },		
    // 显示服务商的特殊产品
    async getspecialGoodsNameOptions() {
		if(this.form.providerDepartment.length > 0){
			let specialGoodsName = await this.$api.getspIdSpecialGoodsName(this.form.providerDepartment[0])
			this.specialGoodsNameOptions = specialGoodsName.value.split(';')
		}else{
			this.specialGoodsNameOptions = []
		}
    },
    // 业务类型树
    async getBiztype() {
      this.biztypeOptions = await this.$api.biztype()
    },
    // 查价日志
    async getcustomerquote() {
      this.customerquote = await this.$api.customerquote()
    },
    // 国家
    async getCountrylist() {
      this.countryOptions = await this.$api.countrylist()
      this.filterCountry()
    },
    // 国家过滤
    async filterCountry(country) {
      if (country) {
        let countryOptionsCrror = this.countryOptions.filter((options) => {
          // 国家包含二字码(大写),中文,英文(小写),中文首字母(大写),拼音(小写)对比并排序
          return options.countryCode.indexOf(country.toUpperCase()) != -1 || options.nameChinese.indexOf(country) != -1 || options.nameEnglish.toLowerCase().indexOf(country.toLowerCase()) != -1 || options.firstPinYin.indexOf(country.toUpperCase()) != -1 || string.getPinYinFirstCharacter(options.nameChinese).indexOf(country.toLowerCase()) != -1
        })
        countryOptionsCrror.sort((a, b) => {
          let crr_a = a.countryCode == country.toUpperCase() || a.nameChinese == country || a.nameEnglish.toLowerCase() == country.toLowerCase() || a.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(a.nameChinese.toLowerCase()) == country.toLowerCase()
          let crr_b = b.countryCode == country.toUpperCase() || b.nameChinese == country || b.nameEnglish.toLowerCase() == country.toLowerCase() || b.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(b.nameChinese.toLowerCase()) == country.toLowerCase()
          if (crr_a && !crr_b) return -1
          return 1
        })
        this.countryOptionsCrror = countryOptionsCrror
      } else {
        this.countryOptionsCrror = this.countryOptions
      }
    },
    // 服务商
    async getproviderlist() {
		let res = await this.$api.branch('3,4')
		for(let i = 0, len = res.list.length; i < len; i++){		
			let option = {
				value: res.list[i].branchCode,
				label: res.list[i].branchName,
			}
			if(res.list[i].branchCode == '85689'){
				//LHD特殊处理
				let setting = await this.$api.getDepartmentSetting('85689')
				if(setting && setting.value){
					let departArr = setting.value.split(",")
					option.children = []
					departArr.forEach((departName)=>{
						let childOption = {
							value: departName,
							label: departName
						}
						option.children.push(childOption);
					})
				}
			}
			this.providerOptions.push(option)
		}
		if(this.providerOptions.length > 0){
			this.form.providerDepartment = [this.providerOptions[0].value]
			this.form.providerCode = this.providerOptions[0].value
			this.salesMan = await this.$api.getProviderSalesMan(localStorage.getItem('tenantId'), this.form.providerCode)
			let setting = await this.$api.getProviderAppSetting(this.form.providerCode);
			this.providerAppSetting = JSON.parse(setting.value)
		}	  
		return; 
    },
    // 服务商过滤
    providerFilter(provider) {
      if (provider) {
        let filteredProviders = this.providerList.filter((options) => {
          // 服务商包含编码(小写),中文,中文首字母(大写),中文拼音(小写)对比并排序
          return options.branchName.indexOf(provider) != -1 || options.firstPinYin.indexOf(provider.toUpperCase()) != -1 || string.getPinYinFirstCharacter(options.branchName).indexOf(provider.toLowerCase()) != -1
        })
		//console.log(filteredProviders)
        filteredProviders.sort((a, b) => {
          let crr_a = a.branchCode == provider.toUpperCase() || a.branchName == provider || a.firstPinYin == provider.toUpperCase() || string.getPinYinFirstCharacter(a.branchName.toLowerCase()) == provider.toLowerCase()
          let crr_b = b.branchCode == provider.toUpperCase() || b.branchName == provider || b.firstPinYin == provider.toUpperCase() || string.getPinYinFirstCharacter(b.branchName.toLowerCase()) == provider.toLowerCase()
          if (crr_a && !crr_b) return -1
          return 1
        })
        this.filteredProviders = filteredProviders		
      } else {
        this.filteredProviders = this.providerList
      }
    },	
    // 业务类型切换
    async bizTypeChange(val) {
      this.form.bizType = [...this.form.bizType]
      this.form.serviceTypeOptions = []
      this.form.serviceType = ''
      if (val.length == 1) {
        const bizTypeList = await this.$api.getBizTypeEntity({ bizType: val[0] })
        if (bizTypeList.length && bizTypeList[0].serviceType) {
          this.serviceTypeOptions = bizTypeList[0].serviceType.split(',')
        }
      }
    },
    // 邮编
    async remoteMethodPostCode(postCode) {
      if (postCode !== '') {
        this.countrycityOptions = []
        let countrycityOptions = await this.$api.countrycitysearchpage({
          countryCode: this.form.countryCode,
          postCode,
          pageNum: 1,
          pageSize: 500
        })
        this.countrycityOptions = countrycityOptions.list
      } else {
        this.countrycityOptions = []
      }
    },
    // 城市
    async remoteMethodCityName(cityName) {
      if (cityName !== '') {
        this.countrycityOptions = []
        let countrycityOptions = await this.$api.countrycitysearchpage({
          countryCode: this.form.countryCode,
          cityName,
          pageNum: 1,
          pageSize: 500
        })
        this.countrycityOptions = countrycityOptions.list
      } else {
        this.countrycityOptions = []
      }
    },
    // 同步邮编城市
    changePostCodeCityName(countrycityOptions, i) {
      if (i === '') {
        return this.changeCountry()
      }
      this.form.postCode = countrycityOptions[i].postCode
      this.form.cityName = countrycityOptions[i].cityName
    },
    // 被重置邮编和城市
    changeCountry() {
      console.log(this.form.countryCode)
      delete this.form['postCode']
      delete this.form['cityName']
      this.countrycityOptions = []
    },
    // 目的地回车
    valueDeclaredkeyupEnter() {
      if (this.form.countryCode) {
        this.$refs['inputWeight'].focus()
      }
    },
    // 重量回车
    weightkeyupEnter() {
      if (this.form.countryCode && this.form.weightText) {
        this.submitForm()
      }
    },
	isNumeric(value) {
	    return !isNaN(value) && !isNaN(parseFloat(value));
	},
    // 表格查询
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (!valid) return
		if((!this.form.weightText) || ((this.form.weightText != '按尺寸') && !this.isNumeric(this.form.weightText)))return
		if(this.form.weightText != '按尺寸'){
			this.form.weight = Number(this.form.weightText)
			if(isNaN(this.form.weight))return
		}
        this.tableSearch = ''
        try {
          this.tableloading = true
          this.tableData = [] // 解决echar部分不刷新
          await this.sendformula()
        } catch (error) {
          this.tableData = []
          this.$message.warning(error)
          // alert('提示：如遇查价无数据，请刷新浏览器')
        } finally {
          this.tableloading = false
        }
      })
    },
    formatpackTypeLabel({ cellValue, row }) {
      let ptype = row.packageType
      let ptypeItem = this.packageType.find(item => item.value === ptype)
      if (ptypeItem && ptypeItem.label) {
        return ptypeItem.label
      }
      return ''
    },	
    //  系统
    async sendformula() {
      let arr = this.form.providerDepartment
      this.form.providerCode = arr.length > 0? arr[0]:''
      this.form.departmentName = arr.length > 1?arr[1]:''
      const res = await this.$api.sendformula(this.form)
      this.tableData = this.tableData.concat(res)
      this.tableData.sort((a, b) => (parseFloat(a.amount) < parseFloat(b.amount) ? -1 : 1))
      this.countProviderQuotes(this.tableData)
      this.buildFilterOptions(this.tableData)
      this.tableSortFilter = {
        orderBy: 1,
        battery: 0,
        bizType: ''
      }
    },
    buildFilterOptions(tableData){
      this.tableBizTypeFilterOptions = []
      this.biztypeOptions.forEach((bizGroup)=>{
        bizGroup.children.forEach((item)=>{
          let len = tableData.filter(e=>(e.bizType == item.name)).length
          if(len > 0){
            this.tableBizTypeFilterOptions.push({label: item.name + '  ' + len, value: item.name})
          }
        })
      })
      this.tableBatteryFilterOptions = [{label:"电池报关(不限)", value:0}]
      let len = tableData.filter((options) => {return options['canBatteryInside']}).length
      if(len > 0){
        this.tableBatteryFilterOptions.push({label:"接内电 " + len, value:1})
      }
      len = tableData.filter((options) => {return options['canBatteryWith']}).length
      if(len > 0){
        this.tableBatteryFilterOptions.push({label:"接外电 " + len, value:2})
      }
      len = tableData.filter((options) => {return options['canBatteryAll']}).length
      if(len > 0){
        this.tableBatteryFilterOptions.push({label:"接纯电 " + len, value:3})
      }
      len = tableData.filter((options) => {return options['canDeclare']}).length
      if(len > 0){
        this.tableBatteryFilterOptions.push({label:"接报关 " + len, value:4})
      }
      len = tableData.filter((options) => {return options['providerSpecialGoods']}).length
      if(len > 0){
        this.tableSpecialGoodsLabel = "接特殊物品 " + len
      }
    },
    // 取消
    cancel() {},
    // 重置表格
    resetForm() {
      this.$refs['form'].resetFields()
    },
    async insertEvent() {
		await this.$refs.xTable.blur()
		const {fullData} = await this.$refs.xTable.getTableData()
		if(fullData.length > 0){
			for(let record of fullData){
				if((!record.caseCount) || (!record.realWeight) || (!record.len) || (!record.width) || (!record.height) || (!record.packageType)){
					return
				}
			}
		}
		const { row: newRow } = await this.$refs.xTable.insert()
		this.$refs.xTable.setActiveCell(newRow, 'caseCount')
    },
    removeEvent(row) {
      this.$refs.xTable.remove(row)
    },
    // 重置弹窗
    resetFormdia() {
      this.form.volumeDiv = ''
      this.form.valueDeclared = ''
      this.form.bizType = []
      this.form.serviceType = ''
      this.form.postCode = ''
      this.form.cityName = ''
      this.form.scanDetails = []
	  this.tableScanDetails = []
    },
	btnSizeClick(){
		this.tableScanDetails = []
		for(let detail of this.form.scanDetails){
			this.tableScanDetails.push({...detail})
		}
		if(this.tableScanDetails.length < 3){
			for(let i = this.tableScanDetails.length; i < 3; i++){
				this.tableScanDetails.push({caseCount: 1, packageType: 1})
			}
		}
		this.diaparams = true
	},	
    // 确定
    async okFormdia() {
		const {fullData} = await this.$refs.xTable.getTableData()
		console.log(fullData)
		this.form.scanDetails = []		
		this.form.weightText = ''				
		if(fullData.length > 0){
			for(let record of fullData){
				if((!record.caseCount) || (!record.realWeight) || (!record.len) || (!record.width) || (!record.height) || (!record.packageType)){
					continue
				}
				this.form.scanDetails.push(record)
			}
			if(this.form.scanDetails.length > 0){
				this.form.weightText = '按尺寸'
			}
		}
		this.diaparams = false		
    },
    mmFillSize(){
        let details = this.parseScanDetails()
        if(details.length > 0){
            for(let detail of details){
                if(detail.len > 0){
                    detail.len = detail.len / 10
                }
                if(detail.width > 0){
                    detail.width = detail.width / 10
                }
                if(detail.height > 0){
                    detail.height = detail.height / 10
                }
            }
			this.tableScanDetails = []
            this.tableScanDetails.push(...details)
        }
    },
    cmFillSize(){
        let details = this.parseScanDetails()        
        if(details.length > 0){
			this.tableScanDetails = []
            this.tableScanDetails.push(...details)
        }
    },
    parseScanDetails(){
        let result = []
        if(this.scanDetailText){
            let lines = this.scanDetailText.split('\n')
			for(let st of lines){
				if(st){
				    let weight = 0
				    let len = 0
				    let width = 0
				    let height = 0
				    let caseCount = 1
					let content = st.toUpperCase().trim()
					let values = content.replace(/\s+/g, ' ').split(' ')
					if((values.length == 5) || (values.length == 4)){
						let weightStr = values[0]
						let caseCountStr = "1"
						if(values.length == 5){
							caseCountStr = values[4]
							if(values[0].indexOf('件') >= 0){
								caseCountStr = values[0]
								weightStr = values[4]
							}else
							if((values[0].indexOf('KG') < 0) && (values[4].indexOf('件') < 0) && (/^\d+$/.test(values[0]))){
								let a1 = parseInt(values[0])
								let a2= parseInt(values[4])
								if(a1 < a2){
									caseCountStr = values[0]
									weightStr = values[4]									
								}
							}
						}
						caseCount = parseInt(caseCountStr.replace('件', ''))
						weight = parseFloat(weightStr.replace('KG', ''))
						len = parseFloat(values[1])
						width = parseFloat(values[2])
						height = parseFloat(values[3])
						if(weight && len && width && height && caseCount){
							result.push({
								'realWeight': weight,
								'len': len,
								'width': width,
								'height': height,
								'caseCount': caseCount,
								'packageType': 1
							})
						}
					}						
				}
			}
		}
		return result
	},
    // 点击行
    rowClick(row) {
      this.$refs.refTable.toggleRowExpansion(row)
    },
    // 预报
    goDelivery(option, form) {
      this.$router.push({ name: 'Delivery', params: { option, form } })
    },
    // 报价明细
    async goquotedetails(row) {
      this.$router.push({ name: 'QuotedDetails', params: { list: [row] } })
    },
  }
}
</script>

<style>
.vxe-select--panel {
  z-index: 5000 !important;
}
</style>

<style scoped>
.option {
  margin-left: 40px;
}
.el-table /deep/ .el-table__expanded-cell {
  background: #f2ffff !important;
  padding: 15px;
  line-height: 32px;
}
.el-divider--horizontal {
  margin: 4px 0;
}
.diaoption {
  margin-left: 40px;
  display: inline-block;
  max-width: 800px;
  padding: 0 5px;
  color: #66b1ff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
}
.diaoption /deep/ label + label {
  margin-left: 40px;
}
.biztype-select /deep/ .el-input__inner {
  background-color: #FFFFCC;
  color: red;
}

.biztype-select /deep/ .el-input__inner::placeholder {
  background-color: #FFFFCC;
  color: red;
}
</style>
